'use client';

import { IcBoldArrowUp } from '@musinsa/mds';
import type { FC } from 'react';
import { twMerge } from 'tailwind-merge';
import { useIsScrollTop } from '../hooks/useIsScrollTop';
import type { PropsWithStyles } from '../types';

export const ScrollToTopButton: FC<PropsWithStyles> = ({ className, ...props }) => {
  const { isScrollTop } = useIsScrollTop({ defaultValue: true });

  const handleScrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  if (isScrollTop) return null;

  return (
    <button
      onClick={handleScrollToTop}
      type="button"
      aria-label="페이지 상단으로 이동"
      className={twMerge(
        'w-[40px] h-[40px] rounded-full bg-white border border-gray-200 flex items-center justify-center',
        className,
      )}
      {...props}
    >
      <IcBoldArrowUp width="28" height="28" strokeColor="black" />
    </button>
  );
};
